import {GenUploadedFile} from '../../generated/serverModels/GenUploadedFile';

export class UploadedFile extends GenUploadedFile {

  public file: File;

  constructor(uploadedFile?: UploadedFile) {
    super(uploadedFile);
  }
}
